export const createObjectUrl = (source: Blob | MediaSource): string => URL.createObjectURL(source);

export const isObjectUrl = (url: string | null | undefined): url is string =>
  typeof url === 'string' && url.startsWith('blob:');

export const revokeObjectUrl = (url: string | null | undefined) => {
  if (!isObjectUrl(url)) {
    return;
  }

  URL.revokeObjectURL(url);
};
